import React from 'react'
import { Button, ButtonType } from '@UI/components/controls/Button/Button.tsx'
import { ArrowPointerLeft } from '@UI/components/icons/ArrowPointerLeft.tsx'
import { ColorNames } from '@UI/theme/generated/ColorNames.ts'
import { Stack } from '../Stack/Stack.tsx'
import styles from './PageWithPicture.module.less'

interface Props {
    children: [picture: React.ReactNode, content: React.ReactNode]
    backLink?: string
}

export const PageWithPicture: React.FC<Props> = ({ backLink, children: [picture, content]}) => (
    <Stack grow alignItems='center' className={styles.root} justifyContent={"center"} direction={"column"}>
        {backLink && (
            <Button
                className={styles.backLink}
                href={backLink}
                color={ColorNames.OBSIDIAN}
                icon={<ArrowPointerLeft size={30} />}
                type={ButtonType.text}
            />
        )}
        <div className={styles.side}>{picture}</div>
        <div className={styles.side}>{content}</div>
    </Stack>
)
